import CircularProgress from "@mui/material/CircularProgress";
import InfoTooltip from 'components/InfoTooltip';
import { LabelField } from 'components/LabelField';
import { convertUTCToLocalDate } from "components/UTC/UtcConverter";
import { getDateFormat, getDateFormatForDatePicket, maskDate } from 'helper/dateFormat';
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import MaskedInput from 'react-text-mask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import MyButton from "../../../components/MyButton";

const SnoozeModal = ({closeModal, updateTaskHandler, selectedTask, updateTaskLoading}) => {
  const dateMask = maskDate();
  const placeholderFormat = getDateFormat();
  const dateFormat = getDateFormatForDatePicket();
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(dateFormat || 'mm/dd/yyyy');

  const [date, setDate] = useState(null);

  const minDate = new Date(new Date().getTime() + 86400000);


  
	function convertLocalToUTCDate(date) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes())
    );
    setDate(date);
    return date;
  }
	



  const snoozeHandler = () => {
    updateTaskHandler({
			key: 2,
			id: selectedTask?.id,
			snoozeValue: date,
			successMsg: "Task snoozed Successfully",
		});
  }

  return (
    <div className=" assign-drawer p-10  mt-5 h-100" style={{ width: "487px" }}>
      <h1 className="NewEvent-heading d-flex align-items-center">
        Snooze
        <InfoTooltip text="Postpones this task until the date you pick." style={{ marginLeft: '6px' }} />
      </h1>
      <div
        className="addEvent-form d-flex flex-column justify-content-between mt-5"
        style={{ height: "82%" }}
      >
        <>
          <div className="form-group Account-name-newEvent  mt-5 h-100 ">
            <LabelField title="Select Date" mandatory={true} />
            <DatePicker
              isClearable
              showIcon
              placeholderText={placeholderFormat}
              dateFormat={dateFormat}
              selected={
                date && 
                convertUTCToLocalDate(date)
              }
              onChange={(date) => {
                convertLocalToUTCDate(date);
              }}
              minDate={minDate}
              customInput={
                <MaskedInput
                  pipe={autoCorrectedDatePipe}
                  mask={dateMask}
                  keepCharPositions={true}
                  guide={true}
                />
              }
            />
          </div>
          <div className="d-flex justify-content-between mt-20">
            <a
              className="close-btn d-flex align-items-center"
              onClick={() => closeModal()}
            >
              Close
            </a>
            <div className="saveBtn-drawer">
              <MyButton
                type={"primary"}
                content={updateTaskLoading ? (
                  <div className="d-flex align-items-center justify-content-center">
                    <CircularProgress
                      size={20}
                      style={{
                        color: "#ffffff",
                      }}
                    />
                  </div>
                ) : (
                  "Save"
                )}
                onClick={() => {
                  snoozeHandler();
                }}
                disabled={!date || updateTaskLoading}
                variant="outlined"
              />
            </div>
          </div>
        </>
      </div>
    </div>
  )
}

export default SnoozeModal